var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Artboard1",
    transform: "matrix(1.25,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.8,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.8,21.747C5.825,21.769 5.851,21.789 5.878,21.809C6.059,21.941 6.27,22.003 6.479,22L6.527,21.998C6.572,21.995 6.617,21.99 6.661,21.981C6.772,21.993 6.885,22 7,22L23,22C23.32,22 23.621,21.847 23.809,21.588L29.597,13.621C29.818,13.317 29.85,12.914 29.679,12.579C29.509,12.244 29.164,12.033 28.788,12.033L25.939,12.033L26,8C26,6.354 24.646,5 23,5L14.535,5C14.535,5 12.832,2.445 12.832,2.445C12.647,2.167 12.334,2 12,2L7,2C5.354,2 4,3.354 4,5C4,5 4,19 4,19C4,20.22 4.745,21.28 5.8,21.747ZM8.428,20L12.763,14.033L26.826,14.033C26.826,14.033 22.49,20 22.49,20L8.428,20ZM23.939,12.033C23.961,10.57 24,7.993 24,7.987C23.993,7.444 23.544,7 23,7L14,7C13.666,7 13.353,6.833 13.168,6.555C13.168,6.555 11.465,4 11.465,4C11.465,4 7,4 7,4C6.451,4 6,4.451 6,5L6,19C6,19.238 6.085,19.457 6.225,19.629L11.445,12.445L11.445,12.445C11.627,12.196 11.922,12.033 12.254,12.033L23.939,12.033Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpen);
export default __webpack_public_path__ + "static/media/folder-open.81301dea.svg";
export { ForwardRef as ReactComponent };